import type { RemittanceSource } from '../services/remittanceCalculatorApi';

// The corridors LulPay sells today (confirmed by Zerayacob, 31 Oct 2026). The codes are the backend's
// remittance corridor codes (V1_178: ACH/BRIDGE_US/USD, FPS/BRIDGE_UK/GBP, SEPA/BRIDGE_EU/EUR).
export type Corridor = {
  id: 'us' | 'gb' | 'eu';
  corridorCode: string;
  sendCurrency: string;
  flag: string;
  cityId: string;
};

export const CORRIDORS: Corridor[] = [
  { id: 'us', corridorCode: 'BRIDGE_US', sendCurrency: 'USD', flag: '/flags/us.svg', cityId: 'newyork' },
  { id: 'gb', corridorCode: 'BRIDGE_UK', sendCurrency: 'GBP', flag: '/flags/gb.svg', cityId: 'london' },
  { id: 'eu', corridorCode: 'BRIDGE_EU', sendCurrency: 'EUR', flag: '/flags/eu.svg', cityId: 'paris' },
];

/** Uganda pays out in US dollars or shillings (V1_71 / V1_72). */
export const DESTINATION = {
  id: 'ug' as const,
  flag: '/flags/ug.svg',
  cityId: 'kampala',
  payoutCurrencies: ['USD', 'UGX'],
};

/**
 * The flags on the "Mobile money or cash" pill in How it works (Zerayacob, 2 Nov 2026): Uganda first and
 * largest (live today), then Yellow Card payout markets: Kenya and Tanzania (the next wave in
 * PLAN_YELLOWCARD.md), Nigeria, Ghana and South Africa. Flags only; the copy names no destination.
 */
export const PAYOUT_FLAGS: { id: string; flag: string }[] = [
  { id: 'ug', flag: '/flags/ug.svg' },
  { id: 'ke', flag: '/flags/ke.svg' },
  { id: 'tz', flag: '/flags/tz.svg' },
  { id: 'ng', flag: '/flags/ng.svg' },
  { id: 'gh', flag: '/flags/gh.svg' },
  { id: 'za', flag: '/flags/za.svg' },
];

/**
 * Only corridors the live calculator catalogue accepts. Before it answers (or if it fails),
 * show the confirmed list.
 */
export function liveCorridors(sources: RemittanceSource[] | null): Corridor[] {
  if (sources == null) return CORRIDORS;
  const codes = new Set(sources.map((source) => source.corridorCode));
  return CORRIDORS.filter((corridor) => codes.has(corridor.corridorCode));
}
